import type {
  CustomerMemo,
  CustomerMemoCreateRequest,
  CustomerMemoListQuery,
  CustomerMemoPatchRequest,
  PagedCustomerMemos,
} from '@shared/types/customer-memo';
import { api } from './client';

function buildQueryString(query: CustomerMemoListQuery): string {
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(query)) {
    if (value === undefined || value === null || value === '') continue;
    params.set(key, String(value));
  }
  const qs = params.toString();
  return qs.length === 0 ? '' : `?${qs}`;
}

/// 事務所詳細: 事務所直接メモ + 所属弁護士の個別メモを集約 (`firm_id` で取得)。
export async function listFirmMemos(
  firmId: string,
  query: CustomerMemoListQuery = {},
): Promise<PagedCustomerMemos> {
  return api.get<PagedCustomerMemos>(
    `/api/firms/${encodeURIComponent(firmId)}/memos${buildQueryString(query)}`,
  );
}

/// 弁護士詳細: 当該弁護士のメモのみ取得。
export async function listLawyerMemos(
  lawyerId: string,
  query: CustomerMemoListQuery = {},
): Promise<PagedCustomerMemos> {
  return api.get<PagedCustomerMemos>(
    `/api/lawyers/${encodeURIComponent(lawyerId)}/memos${buildQueryString(query)}`,
  );
}

/// 事務所直接メモを作成 (`lawyer_id = NULL`)。
export async function createFirmMemo(
  firmId: string,
  body: CustomerMemoCreateRequest,
): Promise<CustomerMemo> {
  return api.post<CustomerMemo>(`/api/firms/${encodeURIComponent(firmId)}/memos`, body);
}

/// 弁護士個別メモを作成。firm_id はサーバが lawyers.firm_id から導出する。
export async function createLawyerMemo(
  lawyerId: string,
  body: CustomerMemoCreateRequest,
): Promise<CustomerMemo> {
  return api.post<CustomerMemo>(`/api/lawyers/${encodeURIComponent(lawyerId)}/memos`, body);
}

export async function patchCustomerMemo(
  id: string,
  body: CustomerMemoPatchRequest,
): Promise<CustomerMemo> {
  return api.patch<CustomerMemo>(`/api/customer-memos/${encodeURIComponent(id)}`, body);
}

export async function deleteCustomerMemo(id: string): Promise<void> {
  return api.delete(`/api/customer-memos/${encodeURIComponent(id)}`);
}
